import styled from 'styled-components';

export const WrapperConfirmDialog = styled.div`
  padding: 0px 32px 32px 32px;

  > div {
    &:first-child {
      > p {
        color: #161d1f;
        text-align: center;

        &:first-child {
          margin-bottom: 8px;
          font-size: 14px;
          line-height: 20px;

          > span:nth-of-type(2) {
            font-weight: 700;
          }
        }

        &:last-child {
          margin-bottom: 16px;
          font-weight: 700;
        }
      }
    }
  }

  > p {
    margin-top: 8px;
    font-size: 12px;
    line-height: 10px;
    text-align: center;
    color: #161d1f;

    > span {
      color: #1a055d;
      font-weight: 900;
    }
  }
`;
